import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Componente que resetea el scroll a (0,0) cada vez que cambia la ruta.
 * Útil para asegurar que al navegar entre diferentes salones o secciones,
 * el usuario comience desde arriba.
 */
const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
};

export default ScrollToTop;
